import { render, staticRenderFns } from "./ConcernElement.vue?vue&type=template&id=fec6a50e&"
import script from "./ConcernElement.vue?vue&type=script&lang=js&"
export * from "./ConcernElement.vue?vue&type=script&lang=js&"
import style0 from "./ConcernElement.vue?vue&type=style&index=0&id=fec6a50e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports